module.exports = __webpack_public_path__ + "img/profile.6599fcad.svg";